// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"06ddc811","453":"51659aaf","455":"8cc36bc2"}[chunkId] + ".chunk.js";
};